/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CircularProgress from 'components/CircularProgress';
import IconComponent from 'components/common/IconComponent';
import ContainerHeader from 'components/ContainerHeader';
import useWindowSize from 'hooks/useWindowSize';
import { isString } from 'lodash';
import React, { useState } from 'react';

import Drawer from '../Drawer';
import { IBaseStructureProps } from './types';

const BaseStructure: React.FC<IBaseStructureProps> = ({
  leftSide,
  rightSide,
  header,
  headerSide,
  headerBelow,
  children,
  mobileThreshold,
  headerIconName,
  hideLeftBar,
  loading,
  leftSideProps,
  headerStyle,
  headerButton,
}) => {
  // mobile visible state;
  const [leftSideVisibleState, setLeftSideVisible] = useState(false);
  const windowWidth = useWindowSize().width;
  const isMobile = !!mobileThreshold && windowWidth <= mobileThreshold;

  const onFilterClick = () => {
    setLeftSideVisible((c) => !c);
  };

  const isLeftSideMobileVerVisible = !!leftSide && isMobile && leftSideVisibleState;

  return (
    <div className='gx-main-content-wrapper base-structure-wrapper'>
      {loading && <CircularProgress />}
      {!loading && (
        <div className='base-structure'>
          <div className='gx-m-0 base-head'>
            {header && isString(header) && (
              <div className='base-head-upper'>
                <ContainerHeader
                  style={headerStyle}
                  headerIconName={headerIconName}
                  className='base-head-title'
                  headerButton={headerButton}
                  title={header}>
                  {headerSide}
                </ContainerHeader>
                {isMobile && leftSide && (
                  <div className='gx-flex-row gx-align-items-center'>
                    <div className='gx-ml-4' onClick={onFilterClick} style={{ cursor: 'pointer' }}>
                      <IconComponent
                        style={leftSideProps?.mobileToggleIconStyle}
                        name={leftSideProps?.mobileToggleIconName || 'filter'}
                        size={18}
                        color={leftSideVisibleState ? '#038fde' : undefined}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {header && !isString(header) && <div className='base-structure'>{header}</div>}
            {headerBelow && <div className='base-head-under'>{headerBelow}</div>}
          </div>
          <div className='base-body'>
            {leftSide && (
              <>
                <div className={`base-body-left ${isMobile || hideLeftBar ? 'gx-d-none' : ''}`}>{leftSide}</div>
                <Drawer visible={isLeftSideMobileVerVisible} title='User Filter' onClose={onFilterClick}>
                  <div className={`base-body-left ${isMobile || hideLeftBar ? 'mobile' : ''}`}>{leftSide}</div>
                </Drawer>
              </>
            )}
            {children && (
              <div
                className={`base-body-main ${isMobile ? 'mobile' : ''}`}
                style={{ flex: !rightSide ? '1 1 auto' : undefined }}>
                {children}
              </div>
            )}
            {rightSide && <div className='base-body-right'>{rightSide}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(BaseStructure);
